import { AudioCallStatuses } from 'constants/voip';
import { FC, useMemo } from 'react';
import { selectPatientAudioCallStatus } from 'store/call/selectors';
import { useAppSelector } from 'store/hooks';
import calling from 'assets/audio/incallmanager_ringback.mp3';

const CallSound: FC = () => {
  const status = useAppSelector(selectPatientAudioCallStatus);

  const src = useMemo(() => {
    switch (status) {
      case AudioCallStatuses.calling:
        return calling;
      default:
        return null;
    }
  }, [status]);

  if (!src) {
    return null;
  }

  return (
    <audio autoPlay controls loop hidden>
      <source src={calling} type="audio/ogg" />
    </audio>
  );
};

export default CallSound;
